import { ArrowBigLeft, ArrowBigRight } from "lucide-react";
import React, { useState } from "react";

const Carousel = (props) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const totalSlides = React.Children.count(props.children);

  const goNext = () => {
    setCurrentItemIndex((prevIndex => prevIndex === totalSlides - 1 ? 0 : prevIndex + 1))
  }
  const goPrevious = () => {
    setCurrentItemIndex((prevIndex => prevIndex === 0 ? totalSlides - 1 : prevIndex - 1))
  }

  return (
    <>
    
      <div className="relative w-full h-full overflow-hidden">
        <div className="flex h-full transition-transform duration-500 ease-in-out"
        style={{
          width: `${totalSlides * 100}%`,
          transform: `translateX(-${(100 / totalSlides) * currentItemIndex}%)`,
        }}>
          {React.Children.map(props.children, (child, index) => {
            return (
              <div
                className={`w-full h-full transition-all duration-300 block`}
              >
                {child}
              </div>
            );
          })}
        </div>
      </div>
      <div className="absolute left-5 right-5 top-1/2 flex -translate-y-1/2 transform justify-between pointer-events-none">
          <button onClick={goPrevious} className="btn btn-circle pointer-events-auto">
            <ArrowBigLeft />
          </button>
          <button onClick={goNext} className="btn btn-circle pointer-events-auto">
          <ArrowBigRight />
          </button>
        </div>
    </>
  );
};

export default Carousel;
